var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.586 2H5.414a1 1 0 00-.707.293L2.293 4.707A1 1 0 002 5.414v5.172a1 1 0 00.293.707l2.414 2.414a1 1 0 00.707.293h5.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 00.293-.707V5.414a1 1 0 00-.293-.707l-2.414-2.414A1 1 0 0010.586 2z",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.574 8.902l-.51-2.174h-.021l-.51 2.174h1.041zM4 11l1.624-6h.868l1.624 6H7.074l-.306-1.29h-1.42L5.042 11H4zM8.63 11V5h1.542c.599 0 1.052.135 1.358.404.313.27.47.652.47 1.147v2.806c0 .562-.167.977-.5 1.247-.327.264-.8.396-1.42.396H8.63zM9.67 5.809v4.382h.48c.293 0 .5-.059.623-.177.123-.124.184-.315.184-.573v-2.89c0-.236-.058-.419-.174-.548-.115-.13-.326-.194-.633-.194h-.48z",
    fill: "#7D8085"
  })));
}
export default __webpack_public_path__ + "static/ad_folder.8b9c4bfa.svg";
export { SvgAdFolder as ReactComponent };